{
  "deselectedItem": "{item} nicht ausgewählt.",
  "select": "Auswählen",
  "selectedAll": "Alle Elemente ausgewählt.",
  "selectedCount": "{count, plural, =0 {Keine Elemente ausgewählt} one {# Element ausgewählt} other {# Elemente ausgewählt}}.",
  "selectedItem": "{item} ausgewählt."
}
